import gql from "graphql-tag";

export const CREATE_SERVICE_REQUEST = gql`
  mutation CreateServiceRequest($serviceRequest: CreateServiceRequestInput!) {
    createServiceRequest(serviceRequest: $serviceRequest) {
      id
      referenceNumber
      serviceCategory
      issues {
        issueType
        description
        images
      }
      mileage
      dueService
      comments
      accidentDate
      accidentTime
      accidentLocation
      policeReportUrl
      additionalDetails {
        questionId
        question
        answer
        answerType
        options
        selectedOptions
        files
        isMandatory
      }
      status
      createdAt
      updatedAt
      createdBy
      updatedBy
      tenantId
      organisationId
      branchId
      reviewedBy
      reviewedAt
      declineReason
      serviceProviderId
      serviceProviderName
      appointmentDate
      estimatedCompletionDate
      estimatedCost
      actualCost
      notes {
        note
        createdBy
        createdByName
        createdAt
        isCustomerVisible
      }
    }
  }
`;










